import { useCallback, useState } from "react";
import { useProductFruitsApi } from "react-product-fruits";

import { ProductFruitsApi, Tour } from "@components/ProductFruits/types";

const isProductFruitsEnabled = true;

type UseProductFruitsApiInstanceReturn = {
  fireEvent: (eventName: string) => void;
  isTourRunning: (tourId: number) => boolean;
};

export function useProductFruitsApiInstance(): UseProductFruitsApiInstanceReturn {
  const [productFruitsApi, setProductFruitsApi] = useState<ProductFruitsApi | null>(null);

  useProductFruitsApi((productFruits: ProductFruitsApi) => {
    if (!isProductFruitsEnabled) return;
    setProductFruitsApi(productFruits);
  }, []);

  const fireEvent = useCallback(
    (eventName: string) => {
      if (productFruitsApi) {
        productFruitsApi.events.track(eventName);
      }
    },
    [productFruitsApi],
  );

  const isTourRunning = (tourId: number): boolean => {
    if (!productFruitsApi) return false;

    const tour = productFruitsApi.tours.getTours().find((tour: Tour) => tour.id === tourId);

    return tour?.isRunning ?? false;
  };

  return { fireEvent, isTourRunning };
}
